<div class="tt-body" [ngStyle]="{'background-color': isAppExist ? '': '#f1f1f2', 'min-width': isAppExist ? 'unset': '1050px !important'}">
    <app-header [hidden]="isAppExist"></app-header>
    <router-outlet></router-outlet>
    <app-footer [hidden]="isAppExist"></app-footer>
</div>
